import React from 'react';

interface Props {
  children?: any;
}

const GridWrap: React.FC<Props> = (props: Props) => {
  const { children } = props;
  return (
    <>
      <div className="geecko-grid-wrap">
        <div className="geecko-grid-wrap__content">{children}</div>
      </div>
    </>
  );
};

export default GridWrap;
